'use client';

import { Suspense } from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { SignupWizard } from '@/components/signup/signup-wizard';

export default function SignupPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="text-2xl">Create Your Charity Account</CardTitle>
          <CardDescription>
            Get started with TrusteeKit in minutes. Set up your charity profile
            and start accepting donations.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Suspense fallback={null}>
            <SignupWizard />
          </Suspense>
        </CardContent>
      </Card>
    </div>
  );
}
